export const useStyles = (theme) => ({
  root: {
    minHeight: "60vh",
    backgroundSize: "contain",
    backgroundPosition: "right center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  homeTitleStyle: {
    width: "50%",
    fontSize: 30,
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down(640)]: {
      width: "100%",
      alignItems: "center",
      textAlign: "center",
    },
  },
  bodyText: {
    fontSize: 30,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    [theme.breakpoints.down(640)]: {
      fontSize: 24,
      color: "#181818",
      alignItems: "center",
      textAlign: "center",
      fontWeight: "bold",
    },
  },
  bodyFoot: {
    width: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(640)]: {
      width: "100%",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
});
